/**
 * Constantes para las fases del proceso de assessment
 */
import {
  Calendar,
  ClipboardCheck,
  FileBarChart2,
  LayoutDashboard,
  Lightbulb,
  Target
} from 'lucide-react'

import type {
  AssessmentProcessPhase,
  AssessmentProcessPhaseDescription
} from '../types/assessmentProcess.types'

// Tipos para la información de las fases
export type AssessmentProcessPhases =
  | 'maturity'
  | 'gap-analysis'
  | 'recommendations'
  | 'planning'
  | 'reportes'

/**
 * Definición de las fases del proceso de assessment
 */
export const assessmentProcessPhasesDescription: AssessmentProcessPhaseDescription[] = [
  {
    phase: 'dashboard',
    icon: LayoutDashboard,
    title: 'Dashboard',
    subtitle: 'Visión general del Assessment',
    description: 'Resumen general del Assessment y su progreso.'
  },
  {
    phase: 'maturity',
    icon: ClipboardCheck,
    title: 'Fase 1 - Madurez Actual',
    subtitle: 'Evaluación de Madurez Actual',
    description:
      'Evaluación del nivel de madurez actual en las diferentes subcategorías del framework'
  },
  {
    phase: 'gap-analysis',
    icon: Target,
    title: 'Fase 2 - Madurez Objetivo',
    subtitle: 'Definición de Madurez Objetivo',
    description:
      'Definición del nivel objetivo, análisis de brechas y priorización de esfuerzos para abordar las áreas críticas'
  },
  {
    phase: 'recommendations',
    icon: Lightbulb,
    title: 'Fase 3 - Recomendaciones',
    subtitle: 'Generación de Recomendaciones',
    description:
      'Generación y gestión de recomendaciones para mejorar las áreas identificadas en el análisis de brechas'
  },
  {
    phase: 'planning',
    icon: Calendar,
    title: 'Fase 4 - Planificación',
    subtitle: 'Presupuesto y Planificación',
    description:
      'Planificación de la implementación de las recomendaciones, incluyendo el despliegue de tecnologías y la ejecución de servicios y proyectos'
  },
  {
    phase: 'reportes',
    icon: FileBarChart2,
    title: 'Reportes',
    subtitle: 'Descarga de Reportes',
    description:
      'Genera y descarga los reportes del assessment: madurez por función, madurez por categoría y distribución de presupuesto'
  }
]

/**
 * Helper para obtener la descripción de una fase por su clave
 * @param phase - La fase del proceso de assessment
 * @returns Descripción completa de la fase
 */
export const getPhaseDescription = (
  phase: AssessmentProcessPhase
): AssessmentProcessPhaseDescription => {
  return (
    assessmentProcessPhasesDescription.find((p) => p.phase === phase) ?? {
      phase,
      icon: LayoutDashboard,
      title: '',
      subtitle: '',
      description: ''
    }
  )
}
